import * as types from './types';

export const setAuth = (fbUser) => ({
  type: types.SET_AUTH,
  payload: {
    uid: fbUser?.uid || '',
    email: fbUser?.email || '',
  }
});

export const setAuthLoading = (isLoading) => ({
  type: types.SET_AUTH_LOADING,
  payload: isLoading
});

export const clearAuth = () => ({
  type: types.CLEAR_AUTH
});
